document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-gv-size-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.gvSizeOpen);
    if (dialog instanceof HTMLDialogElement) dialog.showModal();
  }
  const close = event.target.closest('[data-gv-size-close]');
  if (close) close.closest('dialog')?.close();
  if (event.target instanceof HTMLDialogElement && event.target.classList.contains('gv-size-guide')) {
    const rect = event.target.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
  }
});
